import { SendData } from "../utils/SendData";
import { getNewUuid } from "../utils/uuid";

// import { SendData } from '../utils/SendData';
export class TraficLightScripts {
  constructor({ type_id, users_id, accessBifurcate = false, lastEvent = -1, actualRoads = [] }) {
    this.type_id = type_id;
    this.users_id = users_id;
    this.accessBifurcate = accessBifurcate;
    this.lastEvent = lastEvent;
    this.actualRoads = actualRoads;
    this.use_group_id = null;

    // console.log(1);

    this.initEventListeners();
    this._start();
  }

  initEventListeners() {

    // console.log('initEventListeners');

    document.getElementById('line').addEventListener("mouseover", this._mouseoverOnTable.bind(this));

    $('#resultTable').on('dblclick', "tbody tr", this._onRowDoubleClick.bind(this));

    document.addEventListener('click', (event) => {

      // console.log('click');

      if (event.target.classList.contains('point-modal-trigger')) {
        this._getPointModal(event.target);
      } else if (event.target.classList.contains('write-event-trigger')) {
        this._writeEvent(event);
      } else if (event.target.classList.contains('submit-save-bifurcate-trigger')) {
        this._submitSaveBifurcate(event.target);
      } else if (event.target.classList.contains('submit-brake-trigger')) {
        this._submitBrake(event.target);
      } else if (event.target.classList.contains('new-request-trigger')) {
        this._newRequest();
      } else if (event.target.classList.contains('save-request-trigger')) {
        this._saveRequest(event.target);
      } else if (event.target.classList.contains('old-request-list-trigger')) {
        const isArchive = event.target.dataset.archive === 'true';
        this._oldRequestList(isArchive);
      }
    });

  }


  // МЕТОДЫ ЗАГРУЗКИ И ОБНОВЛЕНИЯ ОСНОВНОЙ ТАБЛИЦЫ
  async _start() {  // для старта получаем список групп, доступных для данной роли (департамента) в данном светофоре (тип)
    this.uuidKey = await getTabHashAndUuid() + '_TraficLightManager'; // Заменяем слеши на _
    // console.log(2);
    new SendData({
      data: { type_id: this.type_id, uuidKey: this.uuidKey },
      url: window.Redirect.route('getUseGroupID')
    }).then(
      (response) => {
        this.use_group_id = response.answer

        // console.log(this.use_group_id);

        if (this.use_group_id) {
          this._getGroup();
        }
      }
    );

    document.addEventListener('click', (event) => {
      if (event.target.closest('.info-request-trigger')) {   // Проверяем, нажали ли на кнопку info-request-trigger
        event.stopPropagation(); // Останавливаем всплытие события
        this._getInfo(getDataAll(event.target));
        return; // Выходим, чтобы избежать дальнейших проверок
      }
      if (event.target.closest('.repeat-request-trigger')) {   // Проверяем, нажали ли на строку repeat-request-trigger
        event.stopPropagation(); // Останавливаем всплытие события
        this._repeatRequest(getDataAll(event.target));
        return; // Выходим, чтобы избежать дальнейших проверок
      }
    });
  }

  // хранит последнее событие по актуальным road - в целом задействовано для обновления состояния (цветов) point
  _updateLastEvent(newLastEvent) {
    this.lastEvent = newLastEvent;
    // console.log(this.lastEvent);
  }

  _getGroup() {  // получаем основную таблицу 
    // console.log(3);
    new SendData({
      data: { group_id: this.use_group_id, uuidKey: this.uuidKey, type_id: this.type_id },
      url: window.Redirect.route('getRoads')
    }).then(
      (response) => {
        const tableAndRoads = response.answer;
        this.actualRoads = tableAndRoads['roadsIds'];

        $('#type_selector').empty().append(tableAndRoads['select']);
        $('#tableBody').empty().append(tableAndRoads['table']);

        this._updateLastEvent(tableAndRoads['newLastId']);

        // инициализируем титулы (всплывающие подсказки)
        // нужно для корректного отображения всплывающих подсказок (tooltip), которые могут быть частью обновленной таблицы или интерфейса. 
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));

        setInterval(this._getActualRoads.bind(this), 10000);
      }
    );
  }

  _updateGroup() {   // обновляем состояние группы: id последнего события и цвета point-ов
    // console.log(7);
    if (this.use_group_id.length > 0) {
      new SendData({
        data: { use_group_id: this.use_group_id, uuidKey: this.uuidKey },
        url: window.Redirect.route('getLastId')
      }).then((response) => {
        if (response.answer > this.lastEvent) {
          const oldLastId = this.lastEvent;
          const newLastId = response.answer.lastId;
          this._updateLastEvent(newLastId);
          this._partialUpdateGroup(oldLastId, newLastId);
        }
      });
    }
  }

  _partialUpdateGroup(oldLastId, newLastId) {
    // console.log(8);
    if (this.lastEvent !== -1) {
      new SendData({
        data: { use_group_id: this.use_group_id, old_last_id: oldLastId, new_last_id: newLastId, uuidKey: this.uuidKey },
        url: window.Redirect.route('partialUpdateGroup')
      }
      ).then((response) => {
        const answer = response.answer;
        answer.forEach((point) => {
          const pointId = `${point.group_id}_${point.road_id}_${point.point_number}`;
          this._changePointColor(pointId, point.color);
        });
      });
    }
  }

  _changePointColor(pointId, pointNewColor) {
    // console.log(9);
    // console.log(pointId);
    // console.log(pointNewColor);
    const myPoint = document.getElementById(pointId).classList;
    myPoint.forEach((elementClass) => {
      if (elementClass.endsWith('Square')) {
        myPoint.remove(elementClass);
        myPoint.add(`${pointNewColor}Square`);
      }
    });
  }

  // запрос для обновления состояние таблицы - проверяет, есть ли новые строки
  _getActualRoads() {
    // console.log(4);
    new SendData({
      data: { use_group_id: this.use_group_id, actual_roads: this.actualRoads },
      url: window.Redirect.route('getActualRoads')
    }).then((response) => {
      // console.log(5);
      const checkRoads = response.answer;
      if (checkRoads.hasOwnProperty('roads')) {
        this.actualRoads = checkRoads['roads'];

        checkRoads['closed'].forEach((closedRoad) => {
          document.querySelector(`[data-id='${closedRoad}']`).remove();
        });

        if (checkRoads['added'].length > 0) {
          this._addNewRoads(checkRoads['added']);
        }
      }
      this._updateGroup();
    });
  }

  // обновляет состояние таблицы - добавляет новые строки
  _addNewRoads(addedRoads) {
    // console.log(6);
    new SendData({
      data: { roads_ids: addedRoads },
      url: window.Redirect.route('getRoads')
    }).then((response) => {
      const newRoads = response.answer;
      $('#tableBody').prepend(newRoads['table']);

      const newSelectTypes = newRoads['selectData'];
      const options = $('#type_selector option').map((_, option) => $(option).val()).toArray();

      newSelectTypes.filter((value) => !options.includes(value)).forEach((newType) => {
        const newOption = $('<option>').val(newType).text(newType);
        $('#type_selector').append(newOption);
      });
    });
  }


  // РАБОЧИЕ МЕТОДЫ
  // Отвечает за подчёркивание point-ов исполнителя в road
  _mouseoverOnTable(event) {
    // console.log('mouseoverOnTable');
    const roadTd = event.target.closest(".road");
    // console.log(roadTd);
    if (roadTd) {
      // Получаем roadArea внутри roadTd
      const roadArea = roadTd.querySelector(".roadArea");

      // Ищем элементы с executor="true" внутри roadArea
      const myPointOnTheRoad = roadArea.querySelectorAll('[executor="true"]');
      // console.log(myPointOnTheRoad);

      const dotsArray = [];

      myPointOnTheRoad.forEach((point) => {
        // Проверяем, является ли этот элемент исполнителем
        if (point.getAttribute("executor") === "true") {

          // console.log(point);

          const dot = document.createElement("div");
          dot.classList.add('dot', 'hide-print');
          dot.style.position = 'absolute';
          dot.style.backgroundColor = window.getComputedStyle(point).backgroundColor;
          dot.style.top = '35px';
          dot.style.left = '8px';
          point.appendChild(dot);

          // console.log(dot);

          dotsArray.push(dot);
        }
      });

      roadTd.addEventListener('mouseleave', () => {
        dotsArray.forEach((dot) => dot.remove());
      }, { once: true });
    }
  }

  // Обработка двойного клика 
  _onRowDoubleClick(event) {
    const road_id = event.currentTarget.attributes['data-id'].value;
    if (this.type_id === '1' && this.accessBifurcate) {   // в Заказах - открытие модального окна для разделения его на 2 части
      new ModalManager({
        data: {
          road_id: road_id,
        },
        url: window.Redirect.route('getPointModalBifurcate')
      }).open();
    }
    if (this.type_id === '2') {  // в Запросах - открвтие модалки с информацией по запросу
      this._getInfo({ road_id: road_id });   // ! _getInfo используется и при нажатии на кнопку
    }
  }

  // Открыть модалку при нажитии на point
  _getPointModal(event) {

    // console.log('getPointModal');

    const pointData = getDataAll(event);

    // console.log(pointData.data_dep);

    new ModalManager({
      data: {
        type_id: this.type_id,
        full_point_id: pointData.id,
        point_executor: pointData.data_dep,
      },
      url: window.Redirect.route('getPointModal')
    }).open();
  }

  // Сохранить изменения в point
  _writeEvent() {
    const events = document.getElementsByClassName("eventBody");
    const dataResult = new FormData();

    // Проверяем, был ли заказ закрыт в момент изменения
    const firstEventId = events[0].getElementsByClassName("form-input")[0].id.split('_')[2];
    if (this.actualRoads.indexOf(firstEventId) !== -1) {
      for (let i = 0; i < events.length; i++) {
        const formInput = events[i].getElementsByClassName("form-input")[0];
        const type = formInput.getAttribute("data-type");
        const eventId = formInput.id;
        let event_value = "";

        switch (type) {
          case "checkbox":
            event_value = formInput.checked; // true или false
            break;

          case "date":
          case "text":
            event_value = formInput.value; // Получаем значение
            break;

          case "radio":
            const radios = events[i].getElementsByClassName("form-input");
            for (let j = 0; j < radios.length; j++) {
              if (radios[j].checked) {
                event_value = radios[j].value; // Сохраняем значение выбранного радио
                break;
              }
            }
            break;

          case "file":
            const fileInput = formInput.files[0];
            if (fileInput) {
              dataResult.append(eventId, fileInput.name); // Добавляем имя файла
              event_value = fileInput;
            } else {
              const oldFile = events[i].getElementsByClassName("old-file")[0];
              if (oldFile) {
                event_value = oldFile.getAttribute("data-fullname"); // Используем старое имя файла
              }
            }
            break;

          default:
            alert(`Неизвестный тип: ${type}`);
            break;
        }

        // Добавляем данные в FormData
        dataResult.append(eventId, event_value);
      }

      // Дополнительные данные
      dataResult.append("userId", this.users_id);
      dataResult.append("type_id", this.type_id);

      // AJAX-запрос для отправки изменений
      new SendData({
        formData: dataResult,
        url: window.Redirect.route('writeEvent')
      }).then((response) => {
        try {
          const answer = response.answer;
          const { id, color, last_id, updateRequest } = answer;

          // Обновляем последний изменённый event
          this._updateLastEvent(last_id);

          if (updateRequest) {
            this._getActualRoads(); // Обновляем актуальные дороги
          } else {
            this._changePointColor(id, color); // Перекрашиваем point
          }
        } catch (error) {
          console.error("Ошибка обработки ответа:", error);
        }
      });
    } else {
      window.MessageManager.showMessage({ 'text': 'Заказ был закрыт, изменения не применяются.', type: 'warning' });
    }
  }

  // Сохранить разделение заказа на две части
  _submitSaveBifurcate() {
    // Получаем идентификатор TMS
    const bifurcateTmsId = document.getElementById('bifurcate_tms_id').value;

    // Проверяем, открыт ли заказ
    if (this.actualRoads.indexOf(bifurcateTmsId) !== -1) {
      const cntInputValue = document.getElementById('cntInput1').value;

      // Отправляем данные на сервер
      new SendData({
        data: { tms_id: bifurcateTmsId, cnt_input: cntInputValue, },
        url: window.Redirect.route('doBifurcate')
      })
        .then((response) => {
          if (response.answer) {
            // Обновляем актуальные дороги
            this._getActualRoads();
          }
        })
        .catch((error) => {
          // console.error('Ошибка при разделении заказа:', error);
        });
    } else {
      alert('Заказ был закрыт, изменения не применяются.');
    }
  }

  // Обработка СТОП-КРАНА
  _submitBrake(elem) {
    // Запрос комментария у пользователя
    const emergencyBrakeMessage = prompt("Комментарий");
    if (emergencyBrakeMessage !== null) { // Проверяем, что пользователь не нажал "Отмена"
      if (this.type_id === '2') { // Логика для RRR
        // console.log('RRR logic:', button);
      } else {
        // Получаем full_point_id из атрибута data-fullpointid
        const fullPointId = elem.getAttribute('data-fullpointid');
        const department_id = elem.getAttribute('data-department_id');
        const roadId = fullPointId.split('_')[1]; // Извлекаем ID дороги

        // Проверяем, открыт ли заказ
        if (this.actualRoads.indexOf(roadId) !== -1) {
          new SendData({
            data: {
              full_point_id: fullPointId,
              department_id: department_id,
              type_id: this.type_id,
              users_id: this.users_id,
              emergency_brake_message: emergencyBrakeMessage,
            },
            url: window.Redirect.route('updateRoad')
          }).then(() => document.location.reload()
          )
            .catch((error) => {
              // console.error('Ошибка при выполнении СТОП-КРАН:', error);
            });
        } else {
          alert('Заказ был закрыт, изменения не применяются.');
        }
      }
    }
  }

  // Сздание нового запроса
  _newRequest() {
    new ModalManager({
      data: {
        type_id: this.type_id,
      },
      url: window.Redirect.route('newRequestModal')
    }).open();
  }

  // Сохранить запрос
  _saveRequest(elem) {
    const data = getDataAll(elem);
    const modal = elem.closest('.modal.fade');
    const fieldset = modal.querySelector('fieldset');
    if (modal.modalManager._validateForm(fieldset)) {
      new SendData({
        data: data,
        url: window.Redirect.route('saveRequest'), uuidKey: this.uuidKey
      }).then((saveresponse) => {
        if (saveresponse.answer.error) {
          // console.log('Error:', saveresponse.answer.error);
          // alert('Ошибка заполнения формы: ' + saveresponse.answer.error);
        } else {
          try {
            // let answer = JSON.parse(saveresponse.answer);
            modal.modalManager.closeModal();
            this._getActualRoads(); // Обновляем актуальные дороги
          } catch (e) {
            // console.error('Ошибка при парсинге JSON:', e);
          }
        }
      })
    }
  }

  // Получение информации(истории) по рассмотрению запроса (двойной клик по строке)
  _getInfo(data) {
    // console.log(data);
    new ModalManager({
      data: {
        roads_ids: [data.road_id],
        type_id: this.type_id
      },
      url: window.Redirect.route('getInfoRequestModal')
    }).open();
  }

  // Обработка кнопки Архив запросов или Повторить запрос
  _oldRequestList(archive) {
    new ModalManager({
      data: {
        type_id: this.type_id,
        // department_id: this.department_id,
        archive: archive,
      },
      url: window.Redirect.route('oldRequestList')
    }).open();
  }

  // Повторить запроса при клике по строке в Архиве или типа того
  _repeatRequest(data) {
    // console.log(data);
    new ModalManager({
      data: {
        type_id: this.type_id,
        sales_number: data.sales_number
      },
      url: window.Redirect.route('repeatRequest')
    }).open();
  }
}